import React from 'react';

const MarkdownRenderer = React.memo(({ children }) => {
    const renderText = (text) => {
        let html = String(text).replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\*(.*?)\*/g, '<em>$1</em>').replace(/\n/g, '<br />');
        return <span dangerouslySetInnerHTML={{ __html: html }} />; 
    };
    return renderText(children);
});

export default MarkdownRenderer;